import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/apiClient";
import type { GaugeInstance } from "./types";

interface GaugeResponse {
  totalCalls: number;
}

const REFRESH_INTERVAL_MS = 5000;

export function Gauge() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const instanceRef = useRef<GaugeInstance | null>(null);

  const { data } = useQuery({
    queryKey: ["wallboard", "gauge"],
    queryFn: () => apiGet<GaugeResponse>("/api/wallboard/gauge"),
    refetchInterval: REFRESH_INTERVAL_MS,
  });

  useEffect(() => {
    const canvas = canvasRef.current;
    const Gauge = window.Gauge;
    if (!canvas || !Gauge) return;

    const instance = new Gauge(canvas).setOptions({
      angle: -0.25,
      lineWidth: 0.2,
      radiusScale: 1,
      pointer: { length: 0, strokeWidth: 0, color: "#000000" },
      limitMax: false,
      limitMin: false,
      colorStart: "#6FADCF",
      colorStop: "#8FC0DA",
      strokeColor: "#E0E0E0",
      generateGradient: true,
      highDpiSupport: true,
    });
    instance.maxValue = 10;
    instance.setMinValue(0);
    instance.animationSpeed = 32;
    instance.setTextField(textRef.current);
    instance.set(0);
    instanceRef.current = instance;
  }, []);

  useEffect(() => {
    const instance = instanceRef.current;
    if (!instance) return;
    const value = Number(data?.totalCalls) || 0;
    if (value > instance.maxValue) {
      instance.maxValue = value;
    }
    instance.set(value);
  }, [data]);

  return (
    <div className="text-center mb-12 w-full">
      <h1 className="text-2xl">Queue Count</h1>
      <canvas ref={canvasRef} className="mx-auto block w-4/5" />
      <div ref={textRef} className="text-6xl -mt-24">
        0
      </div>
    </div>
  );
}
